<template>
  <div>
    <div class="tip">
      <template v-if="$route.query.from === 'apply'">
        <div class="tip-p">欢迎申请加入 TGO 鲲鹏会</div>
        <div class="tip-p">工作人员收到申请后第一时间联系您审核</div>
        <div class="tip-p">请您耐心等待</div>
        <div class="tip-p">感谢您对 TGO 的支持</div>
      </template>
      <template v-else>
        <div class="tip-p">移动端正在开发中...</div>
        <div class="tip-p">如有需要请先移步PC端,</div>
        <div class="tip-p">给您带来的不便，尽请谅解。</div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style scoped lang='sass'>

.tip
  margin: 0 auto
  height: 100vh
  padding: 0 20px
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  text-align: center
  transform: translateY(-40px)
  .tip-p
    margin-bottom: 10px
</style>
